import { Vue, Component } from "vue-property-decorator";
import { createAxiosInstance } from "../services/base.service";
import { AxiosInstance } from "axios";
import { getModule } from "vuex-module-decorators";
import StoreVuexModule from "@/store/StoreVuexModule";

@Component({})
export default class BaseServiceMixin extends Vue {
  protected axiosInstance!: AxiosInstance;
  protected vuexStore = getModule(StoreVuexModule, this.$store);

  public created() {
    this.axiosInstance = createAxiosInstance(this.$oidc, this.vuexStore.environment);
  }
}
